import { defineDomainTranslations } from './defineDomainTranslations';

const EN_BOOSTERS_TRANSLATIONS = {
  'boosters.about': 'about boosters',
  'boosters.action.add': 'Add boosters',
  'boosters.action.addAndContinue': 'Add and continue',
  'boosters.action.manage': 'Manage',
  'boosters.action.manageBilling': 'Manage billing',
  'boosters.action.renewSubscription': 'Renew subscription',
  'boosters.action.resumeSubscription': 'Resume subscription',
  'boosters.action.saveAndContinue': 'Save and continue',
  'boosters.banner.description': 'Choose the tools you want to add to your workflow',
  'boosters.banner.title': 'Boost your work without changing your plan!',
  'boosters.card.activeUntil': 'Active until {date} with no charges',
  'boosters.card.activeUntilQuantity': '{quantity} × {name} (until {date})',
  'boosters.card.noAvailable': 'No boosters available',
  'boosters.card.quantity': '{quantity} × {name}',
  'boosters.intro.title': 'Add boosters for better results',
  'boosters.item.prompting.description': 'Match your dubbed videos to your brand voice',
  'boosters.item.prompting.title': 'Translation prompting',
  'boosters.item.prompting.tooltip':
    'Set the tone, style, and context with prompts. Use a template or create your own for each translation.',
  'boosters.item.seat.description': 'Collaborate seamlessly with your team on shared projects',
  'boosters.item.seat.title': 'Extra Teamspace seat',
  'boosters.item.seat.tooltip': 'Collaborate with your team in shared Teamspaces.',
  'boosters.item.srt.description': 'Upload and download a corrected transcript',
  'boosters.item.srt.title': 'SRT upload and download',
  'boosters.item.srt.tooltip':
    'Download subtitles with original and translated text, or upload your own to sync them with the dubbing.',
  'boosters.learnMore': 'Learn more',
  'boosters.manage.description':
    'Boost your work without changing your plan — choose the tools you want to add to your workflow.',
  'boosters.manage.title': 'Manage boosters',
  'boosters.perMonth': '{price} / month',
  'boosters.scheduled.activeUntil': 'Active until {date} with no additional charges',
  'boosters.scheduled.seats': 'Active seats: {total} until {date} with no additional charges, then {defaultSeats}.',
  'boosters.seats.addManyForMonth': 'Add {count} seats for {price} per month',
  'boosters.seats.addOneForMonth': 'Add {count} seat for {price} per month',
  'boosters.status.expired': 'Expired',
  'boosters.status.pastDue': 'Past due',
  'boosters.status.paused': 'Paused',
  'boosters.success.changed': 'Payment processed successfully. Your subscription has been updated.',
  'boosters.success.saved': 'Your booster changes have been saved',
  'boosters.title': 'Boosters',
  'boosters.tooltip.add': 'Add boosters',
  'boosters.tooltip.description': 'Add boosters to get better results in just one click.',
  'boosters.tooltip.title': 'Want better results?',
  'boosters.warning.canceled': 'Boosters are unavailable because your subscription is canceled',
  'boosters.warning.expired': 'Boosters are unavailable because your subscription has expired',
  'boosters.warning.failedPayment': 'Paused after a failed payment',
  'boosters.warning.paused': 'Boosters are paused with your subscription',
} as const;

export const BOOSTERS_TRANSLATIONS = defineDomainTranslations({
  en: EN_BOOSTERS_TRANSLATIONS,
  es: {
    'boosters.about': 'sobre los Boosters',
    'boosters.action.add': 'Añadir Boosters',
    'boosters.action.addAndContinue': 'Añadir y continuar',
    'boosters.action.manage': 'Gestionar',
    'boosters.action.manageBilling': 'Gestionar facturación',
    'boosters.action.renewSubscription': 'Renovar suscripción',
    'boosters.action.resumeSubscription': 'Reanudar suscripción',
    'boosters.action.saveAndContinue': 'Guardar y continuar',
    'boosters.banner.description': 'Elige las herramientas que quieres añadir a tu flujo de trabajo',
    'boosters.banner.title': '¡Mejora tu trabajo sin cambiar de plan!',
    'boosters.card.activeUntil': 'Activo hasta el {date} sin cargos',
    'boosters.card.activeUntilQuantity': '{quantity} × {name} (hasta el {date})',
    'boosters.card.noAvailable': 'No hay Boosters disponibles',
    'boosters.card.quantity': '{quantity} × {name}',
    'boosters.intro.title': 'Añade Boosters para obtener mejores resultados',
    'boosters.item.prompting.description': 'Adapta tus videos doblados a la voz de tu marca',
    'boosters.item.prompting.title': 'Prompts de traducción',
    'boosters.item.prompting.tooltip':
      'Define el tono, el estilo y el contexto con prompts. Usa una plantilla o crea la tuya para cada traducción.',
    'boosters.item.seat.description': 'Colabora fácilmente con tu equipo en proyectos compartidos',
    'boosters.item.seat.title': 'Plaza adicional en Teamspace',
    'boosters.item.seat.tooltip': 'Colabora con tu equipo en Teamspaces compartidos.',
    'boosters.item.srt.description': 'Sube y descarga una transcripción corregida',
    'boosters.item.srt.title': 'Carga y descarga de SRT',
    'boosters.item.srt.tooltip':
      'Descarga subtítulos con el texto original y traducido, o sube los tuyos para sincronizarlos con el doblaje.',
    'boosters.learnMore': 'Más información',
    'boosters.manage.description':
      'Mejora tu trabajo sin cambiar de plan: elige las herramientas que quieres añadir a tu flujo.',
    'boosters.manage.title': 'Gestionar Boosters',
    'boosters.perMonth': '{price} / mes',
    'boosters.scheduled.activeUntil': 'Activo hasta el {date} sin cargos adicionales',
    'boosters.scheduled.seats':
      'Puestos activos: {total} hasta el {date} sin cargos adicionales; después: {defaultSeats}.',
    'boosters.seats.addManyForMonth': 'Añade {count} puestos por {price} al mes',
    'boosters.seats.addOneForMonth': 'Añade {count} puesto por {price} al mes',
    'boosters.status.expired': 'Caducado',
    'boosters.status.pastDue': 'Pago atrasado',
    'boosters.status.paused': 'Pausado',
    'boosters.success.changed': 'Pago procesado. Tu suscripción se ha actualizado.',
    'boosters.success.saved': 'Se han guardado los cambios en tus Boosters.',
    'boosters.title': 'Boosters',
    'boosters.tooltip.add': 'Añadir Boosters',
    'boosters.tooltip.description': 'Añade Boosters para obtener mejores resultados con un solo clic.',
    'boosters.tooltip.title': '¿Quieres mejores resultados?',
    'boosters.warning.canceled': 'Los Boosters no están disponibles porque tu suscripción está cancelada',
    'boosters.warning.expired': 'Los Boosters no están disponibles porque tu suscripción ha caducado',
    'boosters.warning.failedPayment': 'Pausados tras un pago fallido',
    'boosters.warning.paused': 'Los Boosters están pausados junto con tu suscripción',
  },
  fr: {
    'boosters.about': 'sur les Boosters',
    'boosters.action.add': 'Ajouter des Boosters',
    'boosters.action.addAndContinue': 'Ajouter et continuer',
    'boosters.action.manage': 'Gérer',
    'boosters.action.manageBilling': 'Gérer la facturation',
    'boosters.action.renewSubscription': "Renouveler l'abonnement",
    'boosters.action.resumeSubscription': "Reprendre l'abonnement",
    'boosters.action.saveAndContinue': 'Enregistrer et continuer',
    'boosters.banner.description': 'Choisissez les outils à ajouter à votre flux de travail',
    'boosters.banner.title': 'Optimisez votre travail sans changer de forfait !',
    'boosters.card.activeUntil': "Actif jusqu'au {date} sans frais supplémentaires liés au Booster",
    'boosters.card.activeUntilQuantity': "{quantity} × {name} (jusqu'au {date})",
    'boosters.card.noAvailable': 'Aucun Booster disponible',
    'boosters.card.quantity': '{quantity} × {name}',
    'boosters.intro.title': 'Ajoutez des Boosters pour de meilleurs résultats',
    'boosters.item.prompting.description': 'Adaptez vos vidéos doublées à la voix de votre marque',
    'boosters.item.prompting.title': 'Prompts de traduction',
    'boosters.item.prompting.tooltip':
      'Définissez le ton, le style et le contexte avec des prompts. Utilisez un modèle ou créez le vôtre pour chaque traduction.',
    'boosters.item.seat.description': 'Collaborez facilement avec votre équipe sur des projets partagés',
    'boosters.item.seat.title': 'Place supplémentaire dans le Teamspace',
    'boosters.item.seat.tooltip': 'Collaborez avec votre équipe dans des Teamspaces partagés.',
    'boosters.item.srt.description': 'Importez et téléchargez une transcription corrigée',
    'boosters.item.srt.title': 'Import et téléchargement SRT',
    'boosters.item.srt.tooltip':
      'Téléchargez les sous-titres avec le texte original et traduit, ou importez les vôtres pour les synchroniser avec le doublage.',
    'boosters.learnMore': 'En savoir plus',
    'boosters.manage.description':
      'Optimisez votre travail sans changer de forfait : choisissez les outils à ajouter à votre flux de travail.',
    'boosters.manage.title': 'Gérer les Boosters',
    'boosters.perMonth': '{price} / mois',
    'boosters.scheduled.activeUntil': "Actif jusqu'au {date} sans frais supplémentaires liés au Booster",
    'boosters.scheduled.seats':
      "Places actives : {total} jusqu'au {date} sans frais supplémentaires, puis {defaultSeats}.",
    'boosters.seats.addManyForMonth': 'Ajouter {count} places pour {price} par mois',
    'boosters.seats.addOneForMonth': 'Ajouter {count} place pour {price} par mois',
    'boosters.status.expired': 'Expiré',
    'boosters.status.pastDue': 'Paiement en retard',
    'boosters.status.paused': 'Suspendu',
    'boosters.success.changed': 'Paiement traité. Votre abonnement a été mis à jour.',
    'boosters.success.saved': 'Les modifications de vos Boosters ont été enregistrées.',
    'boosters.title': 'Boosters',
    'boosters.tooltip.add': 'Ajouter des Boosters',
    'boosters.tooltip.description': 'Ajoutez des Boosters pour de meilleurs résultats en un clic.',
    'boosters.tooltip.title': 'Vous voulez de meilleurs résultats ?',
    'boosters.warning.canceled': 'Les Boosters sont indisponibles car votre abonnement est résilié',
    'boosters.warning.expired': 'Les Boosters sont indisponibles car votre abonnement a expiré',
    'boosters.warning.failedPayment': 'Suspendus après un échec de paiement',
    'boosters.warning.paused': 'Les Boosters sont suspendus en même temps que votre abonnement',
  },
  it: {
    'boosters.about': 'sui booster',
    'boosters.action.add': 'Aggiungi booster',
    'boosters.action.addAndContinue': 'Aggiungi e continua',
    'boosters.action.manage': 'Gestisci',
    'boosters.action.manageBilling': 'Gestisci la fatturazione',
    'boosters.action.renewSubscription': "Rinnova l'abbonamento",
    'boosters.action.resumeSubscription': "Riprendi l'abbonamento",
    'boosters.action.saveAndContinue': 'Salva e continua',
    'boosters.banner.description': 'Scegli gli strumenti da aggiungere al tuo flusso di lavoro',
    'boosters.banner.title': 'Potenzia il tuo lavoro senza cambiare il tuo piano!',
    'boosters.card.activeUntil': 'Attivo fino al {date} senza costi',
    'boosters.card.activeUntilQuantity': '{quantity} × {name} (fino al {date})',
    'boosters.card.noAvailable': 'Nessun booster disponibile',
    'boosters.card.quantity': '{quantity} × {name}',
    'boosters.intro.title': 'Aggiungi booster per risultati migliori',
    'boosters.item.prompting.description': 'Adatta i video doppiati alla voce del tuo brand',
    'boosters.item.prompting.title': 'Prompt di traduzione',
    'boosters.item.prompting.tooltip':
      'Definisci tono, stile e contesto con i prompt. Usa un modello o creane uno per ogni traduzione.',
    'boosters.item.seat.description': 'Collabora facilmente con il team su progetti condivisi',
    'boosters.item.seat.title': 'Postazione Teamspace aggiuntiva',
    'boosters.item.seat.tooltip': 'Collabora con il tuo team nei Teamspace condivisi.',
    'boosters.item.srt.description': 'Carica e scarica una trascrizione corretta',
    'boosters.item.srt.title': 'Caricamento e download SRT',
    'boosters.item.srt.tooltip':
      'Scarica i sottotitoli con testo originale e tradotto oppure carica i tuoi per sincronizzarli con il doppiaggio.',
    'boosters.learnMore': 'Scopri di più',
    'boosters.manage.description':
      'Potenzia il tuo lavoro senza cambiare piano: scegli gli strumenti da aggiungere al flusso.',
    'boosters.manage.title': 'Gestisci i booster',
    'boosters.perMonth': '{price} / mese',
    'boosters.scheduled.activeUntil': 'Attivo fino al {date} senza costi aggiuntivi',
    'boosters.scheduled.seats': '{total} posti attivi fino al {date} senza costi aggiuntivi, poi {defaultSeats} posti.',
    'boosters.seats.addManyForMonth': 'Aggiungi {count} posti per {price} al mese',
    'boosters.seats.addOneForMonth': 'Aggiungi {count} posto per {price} al mese',
    'boosters.status.expired': 'Scaduto',
    'boosters.status.pastDue': 'Pagamento scaduto',
    'boosters.status.paused': 'In pausa',
    'boosters.success.changed': 'Pagamento elaborato. Il tuo abbonamento è stato aggiornato.',
    'boosters.success.saved': 'Le modifiche ai booster sono state salvate.',
    'boosters.title': 'Booster',
    'boosters.tooltip.add': 'Aggiungi booster',
    'boosters.tooltip.description': 'Aggiungi booster per risultati migliori con un solo clic.',
    'boosters.tooltip.title': 'Vuoi risultati migliori?',
    'boosters.warning.canceled': "I booster non sono disponibili perché l'abbonamento è annullato",
    'boosters.warning.expired': "I booster non sono disponibili perché l'abbonamento è scaduto",
    'boosters.warning.failedPayment': 'In pausa dopo un pagamento non riuscito',
    'boosters.warning.paused': "I booster sono in pausa insieme all'abbonamento",
  },
  pt: {
    'boosters.about': 'sobre os Boosters',
    'boosters.action.add': 'Adicionar Boosters',
    'boosters.action.addAndContinue': 'Adicionar e continuar',
    'boosters.action.manage': 'Gerenciar',
    'boosters.action.manageBilling': 'Gerenciar faturamento',
    'boosters.action.renewSubscription': 'Renovar assinatura',
    'boosters.action.resumeSubscription': 'Retomar assinatura',
    'boosters.action.saveAndContinue': 'Salvar e continuar',
    'boosters.banner.description': 'Escolha as ferramentas que deseja adicionar ao seu fluxo de trabalho',
    'boosters.banner.title': 'Potencialize seu trabalho sem mudar de plano!',
    'boosters.card.activeUntil': 'Ativo até {date} sem cobranças',
    'boosters.card.activeUntilQuantity': '{quantity} × {name} (até {date})',
    'boosters.card.noAvailable': 'Nenhum Booster disponível',
    'boosters.card.quantity': '{quantity} × {name}',
    'boosters.intro.title': 'Adicione Boosters para obter melhores resultados',
    'boosters.item.prompting.description': 'Adapte seus vídeos dublados à voz da sua marca',
    'boosters.item.prompting.title': 'Prompts de tradução',
    'boosters.item.prompting.tooltip':
      'Defina o tom, o estilo e o contexto com prompts. Use um modelo ou crie o seu para cada tradução.',
    'boosters.item.seat.description': 'Colabore facilmente com sua equipe em projetos compartilhados',
    'boosters.item.seat.title': 'Vaga adicional no Teamspace',
    'boosters.item.seat.tooltip': 'Colabore com sua equipe em Teamspaces compartilhados.',
    'boosters.item.srt.description': 'Envie e baixe uma transcrição corrigida',
    'boosters.item.srt.title': 'Envio e download de SRT',
    'boosters.item.srt.tooltip':
      'Baixe legendas com o texto original e traduzido ou envie as suas para sincronizá-las com a dublagem.',
    'boosters.learnMore': 'Saiba mais',
    'boosters.manage.description':
      'Potencialize seu trabalho sem mudar de plano: escolha as ferramentas que deseja adicionar ao fluxo.',
    'boosters.manage.title': 'Gerenciar Boosters',
    'boosters.perMonth': '{price} / mês',
    'boosters.scheduled.activeUntil': 'Ativo até {date} sem cobranças adicionais',
    'boosters.scheduled.seats': 'Assentos ativos: {total} até {date} sem cobranças adicionais; depois: {defaultSeats}.',
    'boosters.seats.addManyForMonth': 'Adicione {count} assentos por {price} ao mês',
    'boosters.seats.addOneForMonth': 'Adicione {count} assento por {price} ao mês',
    'boosters.status.expired': 'Expirados',
    'boosters.status.pastDue': 'Pagamento em atraso',
    'boosters.status.paused': 'Pausados',
    'boosters.success.changed': 'Pagamento processado. Sua assinatura foi atualizada.',
    'boosters.success.saved': 'As alterações nos Boosters foram salvas.',
    'boosters.title': 'Boosters',
    'boosters.tooltip.add': 'Adicionar Boosters',
    'boosters.tooltip.description': 'Adicione Boosters para obter melhores resultados com um clique.',
    'boosters.tooltip.title': 'Quer resultados melhores?',
    'boosters.warning.canceled': 'Os Boosters estão indisponíveis porque sua assinatura foi cancelada',
    'boosters.warning.expired': 'Os Boosters estão indisponíveis porque sua assinatura expirou',
    'boosters.warning.failedPayment': 'Pausados após uma falha no pagamento',
    'boosters.warning.paused': 'Os Boosters estão pausados junto com sua assinatura',
  },
  ru: {
    'boosters.about': 'о бустерах',
    'boosters.action.add': 'Добавить бустеры',
    'boosters.action.addAndContinue': 'Добавить и продолжить',
    'boosters.action.manage': 'Настроить',
    'boosters.action.manageBilling': 'Управлять оплатой',
    'boosters.action.renewSubscription': 'Продлить подписку',
    'boosters.action.resumeSubscription': 'Возобновить подписку',
    'boosters.action.saveAndContinue': 'Сохранить и продолжить',
    'boosters.banner.description': 'Выберите инструменты, которые хотите добавить в рабочий процесс',
    'boosters.banner.title': 'Расширьте возможности, не меняя тариф!',
    'boosters.card.activeUntil': 'Активно до {date} без оплаты',
    'boosters.card.activeUntilQuantity': '{quantity} × {name} (до {date})',
    'boosters.card.noAvailable': 'Нет подключённых бустеров',
    'boosters.card.quantity': '{quantity} × {name}',
    'boosters.intro.title': 'Добавьте бустеры для лучшего результата',
    'boosters.item.prompting.description': 'Сохраняйте стиль и тон вашего бренда в озвученных видео',
    'boosters.item.prompting.title': 'Промпты для перевода',
    'boosters.item.prompting.tooltip':
      'Задавайте тон, стиль и контекст с помощью промптов. Используйте шаблон или создайте свой для каждого перевода.',
    'boosters.item.seat.description': 'Работайте с командой над общими проектами',
    'boosters.item.seat.title': 'Дополнительное место в Teamspace',
    'boosters.item.seat.tooltip': 'Работайте с командой в общих пространствах.',
    'boosters.item.srt.description': 'Загружайте и скачивайте исправленные расшифровки',
    'boosters.item.srt.title': 'Загрузка и скачивание SRT',
    'boosters.item.srt.tooltip':
      'Скачивайте субтитры с исходным и переведённым текстом или загружайте свои для синхронизации с озвучкой.',
    'boosters.learnMore': 'Подробнее',
    'boosters.manage.description':
      'Расширьте возможности, не меняя тариф: выберите инструменты для своего рабочего процесса.',
    'boosters.manage.title': 'Управление бустерами',
    'boosters.perMonth': '{price} в месяц',
    'boosters.scheduled.activeUntil': 'Активен до {date} без дополнительной оплаты',
    'boosters.scheduled.seats':
      'До {date} без дополнительной оплаты доступно мест: {total}. Затем останется мест: {defaultSeats}.',
    'boosters.seats.addManyForMonth': 'Добавить места ({count}) за {price} в месяц',
    'boosters.seats.addOneForMonth': 'Добавить {count} место за {price} в месяц',
    'boosters.status.expired': 'Срок действия истёк',
    'boosters.status.pastDue': 'Оплата просрочена',
    'boosters.status.paused': 'Приостановлены',
    'boosters.success.changed': 'Оплата прошла. Подписка обновлена.',
    'boosters.success.saved': 'Изменения бустеров сохранены.',
    'boosters.title': 'Бустеры',
    'boosters.tooltip.add': 'Добавить бустеры',
    'boosters.tooltip.description': 'Добавьте бустеры, чтобы улучшить результат всего в один клик.',
    'boosters.tooltip.title': 'Хотите улучшить результат?',
    'boosters.warning.canceled': 'Бустеры недоступны, потому что подписка отменена',
    'boosters.warning.expired': 'Бустеры недоступны, потому что срок подписки истёк',
    'boosters.warning.failedPayment': 'Приостановлено из-за ошибки оплаты',
    'boosters.warning.paused': 'Бустеры приостановлены вместе с подпиской',
  },
});
